import {IDistance} from './distance'
import {ITime, Time} from './time'
import {Transerializable} from '@eventops/athlinks-get-or'
import {Distance} from '..'

/**
 * PaceType:
 *   pace - time/distance
 *   speed - distance/time
 *   there are cases where a pace doesn't need to be calculated, but we still have the time and distance
 */
export enum PaceType {
  PACE = 'pace',
  SPEED = 'speed',
  NOTCALCULATED = 'notcalculated'
}

export interface IPace {
  distance: IDistance
  time: ITime,
  paceType: PaceType
}

export class Pace extends Transerializable implements IPace {
  distance = new Distance()
  time = new Time()
  paceType = PaceType.SPEED
}